import {
    IntakeQuestion,
    IPaymentStatus,
    ITreatmentPlan,
    TextVisitAttachment,
    TPrescriptionListItem,
} from 'types/textVisit';
import { EIntakeFormStatus, Prospect, TPharmacy } from 'types/common';
import { TServerCalendarAppointmentEventDetail } from 'types/calendar';

export enum EBusinessType {
    APPOINTMENT = 'APPOINTMENT',
    TEXT_VISIT = 'TEXT_VISIT',
    STANDALONE = 'STANDALONE',
}

export interface IVideoTreatment extends ITreatmentPlan {
    businessType?: EBusinessType;
    businessId?: number; // appointment id
}

export enum EAutoSaveBusinessType {
    APPOINTMENT_NOTES = 'APPOINTMENT_NOTES',
    APPOINTMENT_TREATMENT_PLAN = 'APPOINTMENT_TREATMENT_PLAN',
    TEXT_VISIT_NOTES = 'TEXT_VISIT_NOTES',
    TEXT_VISIT_TREATMENT_PLAN = 'TEXT_VISIT_TREATMENT_PLAN',
    TREATMENT_PLAN_TEMPLATE_CONTENT = 'TREATMENT_PLAN_TEMPLATE_CONTENT',
    STANDALONE_TREATMENT_PLAN = 'STANDALONE_TREATMENT_PLAN',
    STANDALONE_NOTES = 'STANDALONE_NOTES',
}

export interface IAutoSaveInfo {
    autoSaveBusinessType: EAutoSaveBusinessType;
    businessId: number;
    content: string;
    id?: number; // visit notes id
    createAt?: string;
    updateAt?: string;
}

export interface IGetAutoSaveHistory {
    businessType: EAutoSaveBusinessType;
    businessId: number;
    pageNum: number;
    pageSize: number;
    updateAt?: string;
}

export interface IAttachment extends TextVisitAttachment {
    businessType: EBusinessType;
    businessId: number;
}

// {
//     "id": 2188,
//     "appointmentName": "patient Evan Liu patient Liu - Psychiatric & Mental Health: New patient initial visit",
//     "providerId": 1446,
//     "clientId": 106711,
//     "startAt": "2026-02-01T16:30:00Z",
//     "endAt": "2026-02-01T17:00:00Z",
//     "duration": 30,
//     "actualDuration": 0,
//     "contactType": "video",
//     "appointmentStatus": "scheduled",
//     "appointmentStatusChangedAt": null,
//     "providerConfirm": false,
//     "providerConfirmAt": null,
//     "clientConfirm": false,
//     "clientConfirmAt": null,
//     "externalVideoLink": "https://meeting.klarity-dev.boxpractice.com/dev_mrr870scmp0s",
//     "notes": "",
//     "reason": "Hi Xiaocong Liu 111,\nI'm looking for a Psychiatric & Mental Health visit. I'd like your help to see me to help me feel better. Thank you.",
//     "scheduledBy": "provider-scheduled",
//     "serviceType": "New patient initial visit",
//     "serviceSpecialty": "Psychiatric & Mental Health",
//     "serviceState": "",
//     "serviceItemId": 1010,
//     "intakeFormStatus": "COMPLETED",
//     "location": "",
//     "telephone": "",
//     "isSample": false,
//     "createdAt": "2026-01-31T14:21:40Z",
//     "updatedAt": "2026-01-31T14:21:40Z",
//     "providerTreatmentSubmitted": true,
//     "providerTreatmentSubmittedAt": "2026-02-02T12:43:57Z",
//     "klarityUserId": 21,
//     "patientFirstName": "Evan Liu",
//     "patientLastName": "Liu",
//     "patientGender": "male",
//     "patientBirthday": "1990-11-08",
//     "patientAge": 35,
//     "patientIdFrontUrl": "https://private-boxpractice-net.s3.ap-northeast-1.amazonaws.com/patient/21/id/2026-02/7a7846c9-99ef-40e5-b643-1bc787d03aa1.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20260202T125222Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1799&X-Amz-Credential=AKIATN6E25IXXSD5C5X6%2F20260202%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Signature=2aa32b022c68d2d9744e44167012d4eacddd6973f8276e02e8bd62d16c4617f4",
//     "patientIdBackUrl": "https://private-boxpractice-net.s3.ap-northeast-1.amazonaws.com/patient/21/id/2026-02/18c6d9de-6b09-4af2-ab73-f1c85ace2617.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20260202T125222Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1799&X-Amz-Credential=AKIATN6E25IXXSD5C5X6%2F20260202%2Fap-northeast-1%2Fs3%2Faws4_request&X-Amz-Signature=58b6befef003b0ed832ac25288ffe146861af600478c7c867ee758cc5922d38e",
//     "idVerified": true,
//     "pharmacySelected": true,
//     "pharmacy": {
//       "ncpDpId": "0000276",
//       "zipCode": "12345",
//       "name": "Kevin's DocuTrack Pharmacy",
//       "address": "201 W. St. John Street  ",
//       "city": "Key West",
//       "state": "FL",
//       "phone": "8642538600"
//     },
//     "state": null,
//     "maritalStatus": "SINGLE",
//     "emergencyContacts": [
//       {
//         "id": 23,
//         "klarityUserId": 21,
//         "fullName": "12",
//         "phone": "9085555555",
//         "relationship": "parent",
//         "priority": 1,
//         "createAt": "2026-02-02T12:47:52",
//         "updateAt": "2026-02-02T12:47:52"
//       }
//     ],
//     "formGroups": [
//       {
//         "businessType": "APPOINTMENT",
//         "businessId": 2188,
//         "formType": "SPECIFIC_INTAKE_FORM",
//         "answers": [
//           {
//             "id": 43,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "56513113",
//             "fullQuestionNameMd5": "5216f5eb076b915e0367eb3bda9b4128",
//             "shortQuestionName": "56513113",
//             "answer": "ADHD, Anxiety",
//             "score": 0,
//             "sort": 2,
//             "createdAt": "2026-02-02T12:48:19.000+00:00",
//             "updatedAt": "2026-02-02T12:48:39.000+00:00"
//           },
//           {
//             "id": 44,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "1540394689",
//             "fullQuestionNameMd5": "c6b5db9e70582c2056142c00bed3923e",
//             "shortQuestionName": "1540394689",
//             "answer": "Yes",
//             "score": 0,
//             "sort": 4,
//             "createdAt": "2026-02-02T12:48:21.000+00:00",
//             "updatedAt": "2026-02-02T12:48:39.000+00:00"
//           },
//           {
//             "id": 45,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "1158157898",
//             "fullQuestionNameMd5": "c18c037c3aa60158e526b7340a66f40c",
//             "shortQuestionName": "1158157898",
//             "answer": "haha",
//             "score": 0,
//             "sort": 6,
//             "createdAt": "2026-02-02T12:48:24.000+00:00",
//             "updatedAt": "2026-02-02T12:48:39.000+00:00"
//           },
//           {
//             "id": 46,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "1849883656",
//             "fullQuestionNameMd5": "5169040d3b81d80747afb879b0132c12",
//             "shortQuestionName": "1849883656",
//             "answer": "Rarely",
//             "score": 0,
//             "sort": 8,
//             "createdAt": "2026-02-02T12:48:27.000+00:00",
//             "updatedAt": "2026-02-02T12:48:38.000+00:00"
//           },
//           {
//             "id": 47,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "569162140",
//             "fullQuestionNameMd5": "9951c88584ae75ceaa3ce052433998ea",
//             "shortQuestionName": "569162140",
//             "answer": "Sometimes",
//             "score": 0,
//             "sort": 9,
//             "createdAt": "2026-02-02T12:48:27.000+00:00",
//             "updatedAt": "2026-02-02T12:48:38.000+00:00"
//           },
//           {
//             "id": 48,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "1425176971",
//             "fullQuestionNameMd5": "b38cb4a12642969ae9e1a3a8e69d30ea",
//             "shortQuestionName": "1425176971",
//             "answer": "Several Days",
//             "score": 0,
//             "sort": 11,
//             "createdAt": "2026-02-02T12:48:31.000+00:00",
//             "updatedAt": "2026-02-02T12:48:45.000+00:00"
//           },
//           {
//             "id": 49,
//             "klarityUserFormId": 21,
//             "sectionName": "",
//             "fullQuestionName": "1008537452",
//             "fullQuestionNameMd5": "e184da0236ed548abfb712b9839ad6a4",
//             "shortQuestionName": "1008537452",
//             "answer": "More than half the days",
//             "score": 0,
//             "sort": 12,
//             "createdAt": "2026-02-02T12:48:31.000+00:00",
//             "updatedAt": "2026-02-02T12:48:44.000+00:00"
//           }
//         ]
//       },
//       {
//         "businessType": "APPOINTMENT",
//         "businessId": 2188,
//         "formType": "BASIC_INITIAL_INTAKE_FORM",
//         "answers": [

//         ]
//       }
//     ],
//     "historyMedical": [
//       "ADHD",
//       "Weight loss"
//     ],
//     "currentMedications": [
//       "Zepbound"
//     ],
//     "allergies": null,
//     "treatmentPlan": {
//       "id": 37,
//       "businessId": 2188,
//       "businessType": "APPOINTMENT",
//       "providerId": 1446,
//       "clientId": null,
//       "treatmentPlan": "<p>take care</p>",
//       "aiTreatmentPlan": null,
//       "aiTreatmentDraftStatus": false,
//       "autoFollowUp": false,
//       "autoFollowUpInterval": null,
//       "autoFollowUpIntervalUnit": "",
//       "autoFollowUpMessage": null,
//       "providerNote": null,
//       "createdAt": "2026-02-02T12:43:57",
//       "updatedAt": "2026-02-02T12:43:57",
//       "attachments": null,
//       "prescriptions": null
//     },
//     "prescriptions": null,
//     "paymentStatus": null,
//     "payoutAmount": null,
//     "providerAppointmentBillings": [

//     ],
//     "providerAppointmentCancelInfo": null,
//     "prospect": {
//       "id": 106711,
//       "providerId": 1446,
//       "email": "evanliu.it@gmail.com",
//       "tel": "9086958801",
//       "address": "Canal St",
//       "gender": "male",
//       "billing": "Self-pay",
//       "carrier": "",
//       "plan": "",
//       "birthday": "1990-11-08",
//       "channelId": null,
//       "firstName": "Evan Liu",
//       "lastName": "Liu",
//       "zip": "12122",
//       "state": "NY",
//       "city": "New York",
//       "idFront": "patient/21/id/2026-02/7a7846c9-99ef-40e5-b643-1bc787d03aa1.jpeg",
//       "idBack": "patient/21/id/2026-02/18c6d9de-6b09-4af2-ab73-f1c85ace2617.jpeg",
//       "cardNum": "xxxx xxxx xxxx 4242",
//       "cardExpirationDate": "",
//       "cardCvc": "",
//       "insurances": [

//       ],
//       "preferMethod": "Text message,Phone call,Email",
//       "type": "Patient",
//       "timezone": "Asia/Shanghai",
//       "preferredName": "",
//       "onBoardingStatus": "COMPLETE",
//       "isSample": false,
//       "chatMessage": null,
//       "maritalStatus": "SINGLE",
//       "emergencyContacts": [
//         {
//           "id": 97,
//           "fullName": "12",
//           "phone": "9085555555",
//           "relationship": "parent",
//           "priority": 1
//         }
//       ],
//       "channel": null,
//       "ehr": "No",
//       "status": "Active",
//       "createTime": "2025-12-18T02:18:18.000+00:00",
//       "updateTime": "2026-02-02T12:48:14.000+00:00",
//       "isRead": 0,
//       "lastReplyBy": "",
//       "lastReplyAt": null,
//       "patientCardNum": null,
//       "patientCardExpirationDate": "12/27",
//       "patientCardCvc": null,
//       "creditCardOnFile": true,
//       "pharmacy": [
//         {
//           "ncpDpId": "0000276",
//           "zipCode": "12345",
//           "name": "Kevin's DocuTrack Pharmacy",
//           "address": "201 W. St. John Street  ",
//           "city": "Key West",
//           "state": "FL",
//           "phone": "8642538600"
//         }
//       ],
//       "medicalHistory": [
//         "ADHD",
//         "Weight loss"
//       ],
//       "allergies": null,
//       "medications": [
//         "Zepbound"
//       ],
//       "conditionHealth": {
//         "klarityUserId": null,
//         "notSure": false,
//         "featured": [
//           "ADHD",
//           "Weight loss"
//         ],
//         "specialty": [

//         ]
//       },
//       "medicationHealth": {
//         "notTaking": false,
//         "medications": [
//           "Zepbound"
//         ],
//         "others": [

//         ]
//       },
//       "allergyHealth": {
//         "hasAllergy": true,
//         "allergies": [

//         ]
//       },
//       "prospectChangeContext": {
//         "pharmacyUpdated": true,
//         "newPharmacyVersionId": 1247,
//         "pharmacyUpdatedBy": "Evan Liu Liu",
//         "pharmacyUpdatedAt": "2026-02-02T07:59:57",
//         "allergyUpdated": true,
//         "newAllergyVersionId": 1246,
//         "allergyUpdatedBy": "Evan Liu Liu",
//         "allergyUpdatedAt": "2026-02-02T07:59:48",
//         "medicationsUpdated": true,
//         "newMedicationsVersionId": 1272,
//         "medicationsUpdatedBy": "Evan Liu Liu",
//         "medicationsUpdatedAt": "2026-02-02T12:47:57",
//         "medicalHistoryUpdated": true,
//         "newMedicalHistoryVersionId": 1271,
//         "medicalHistoryUpdatedBy": "Evan Liu Liu",
//         "medicalHistoryUpdatedAt": "2026-02-02T12:47:55",
//         "oldMedicalHistory": [
//           "Acne treatment",
//           "Pain management",
//           "Anxiety",
//           "Online prescription"
//         ],
//         "oldMedications": [
//           "Cleocin T (clindamycin)"
//         ],
//         "oldAllergies": [
//           "COVID-19 vaccine, AZD-1222  (AstraZeneca)",
//           "acrylates/c 12-22 alkylmethacrylate copolymer"
//         ],
//         "oldPharmacy": [
//           {
//             "ncpDpId": "0519819",
//             "zipCode": "937267120",
//             "name": "RITE AID-4224 E SHIELDS AVE",
//             "address": "4224 EAST SHIELDS AVENUE  ",
//             "city": "FRESNO",
//             "state": "CA",
//             "phone": "5592296024"
//           }
//         ]
//       },
//       "prescribed": false,
//       "online": true
//     },
//     "upcomingVisitAppointments": [
//       {
//         "id": 2187,
//         "appointmentName": "patient Evan Liu patient Liu - Psychiatric & Mental Health: New patient initial visit",
//         "providerId": 1446,
//         "clientId": 106711,
//         "startAt": "2026-02-04T16:30:00Z",
//         "endAt": "2026-02-04T17:00:00Z",
//         "duration": 30,
//         "actualDuration": 0,
//         "contactType": "video",
//         "appointmentStatus": "scheduled",
//         "appointmentStatusChangedAt": null,
//         "providerConfirm": false,
//         "providerConfirmAt": null,
//         "clientConfirm": false,
//         "clientConfirmAt": null,
//         "providerTreatmentSubmitted": false,
//         "providerTreatmentSubmittedAt": null,
//         "externalVideoLink": "https://meeting.klarity-dev.boxpractice.com/dev_mrdahel0fkj4",
//         "notes": "",
//         "reason": "",
//         "scheduledBy": "provider-scheduled",
//         "serviceType": "New patient initial visit",
//         "serviceSpecialty": "Psychiatric & Mental Health",
//         "serviceState": "",
//         "serviceItemId": 1131,
//         "location": "",
//         "telephone": "",
//         "isSample": false,
//         "createdAt": "2026-01-31T03:34:25Z",
//         "updatedAt": "2026-01-31T03:34:25Z",
//         "calendarColor": "#D3EBFF",
//         "recurringAppointmentId": 0,
//         "emailSignature": "",
//         "providerAppointmentCancelInfo": null,
//         "providerAppointmentBillings": null,
//         "hasTextVisitTreatment": null,
//         "textVisitTreatmentVo": null,
//         "attachmentCount": null,
//         "prescriptions": null,
//         "providerFirstName": null,
//         "providerLastName": null,
//         "providerCredential": null,
//         "providerPhoto": null,
//         "intakeFormStatus": "NONE",
//         "intakeFormCompletedAt": null
//       }
//     ]
//   }

export type TProspectChangeContext = {
    pharmacyUpdated: boolean;
    newPharmacyVersionId: string | null;
    pharmacyUpdatedBy: string;
    pharmacyUpdatedAt: string;
    allergyUpdated: boolean;
    newAllergyVersionId: string | null;
    allergyUpdatedBy: string;
    allergyUpdatedAt: string;
    medicationsUpdated: boolean;
    newMedicationsVersionId: string | null;
    medicationsUpdatedBy: string;
    medicationsUpdatedAt: string;
    medicalHistoryUpdated: boolean;
    newMedicalHistoryVersionId: string | null;
    medicalHistoryUpdatedBy: string;
    medicalHistoryUpdatedAt: string;
    oldMedicalHistory: string[];
    oldMedications: string[];
    oldAllergies: string[];
    oldPharmacy: TPharmacy[];
};

// {
//     "businessType": "APPOINTMENT",
//     "businessId": 2188,
//     "formType": "SPECIFIC_INTAKE_FORM",
//     "answers": [
//       {
//         "id": 58,
//         "klarityUserFormId": 21,
//         "sectionName": "Dev-Psychiatry Initial Appointment Intake",
//         "fullQuestionName": "What treatment were you hoping to speak with a practitioner about?",
//         "fullQuestionNameMd5": "a82e9bc24baeb7a0b56cb50fbc9cc994",
//         "shortQuestionName": "What treatment were you hoping to speak with a practitioner about?",
//         "answer": "ADHD",
//         "score": 0,
//         "sort": 0,
//         "createdAt": "2026-02-02T23:46:27.000+00:00",
//         "updatedAt": "2026-02-02T15:47:49.000+00:00"
//       },
//       {
//         "id": 57,
//         "klarityUserFormId": 21,
//         "sectionName": "4. Mental Health Screening",
//         "fullQuestionName": "1. How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done? [Scoring]",
//         "fullQuestionNameMd5": "3e59095dd1b8042d13391df425633bd7",
//         "shortQuestionName": "1. How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done? [Scoring]",
//         "answer": "[1] - Rarely",
//         "score": 1,
//         "sort": 1,
//         "createdAt": "2026-02-02T23:46:26.000+00:00",
//         "updatedAt": "2026-02-02T15:47:49.000+00:00"
//       }
// }
export type TFormAnswer = {
    id: number;
    klarityUserFormId: number;
    sectionName: string;
    fullQuestionName: string;
    fullQuestionNameMd5: string;
    shortQuestionName: string;
    answer: string;
    score: number;
    totalScore: number;
    sort: number;
    createdAt: string;
    updatedAt: string;
};

export type TFormGroup = {
    answers: TFormAnswer[];
    businessType: EBusinessType;
    businessId: number;
    formType: 'BASIC_INITIAL_INTAKE_FORM' | 'SPECIFIC_INTAKE_FORM';
};

export type TEmergencyContact = {
    id: number;
    klarityUserId: number;
    fullName: string;
    phone: string;
    relationship: string;
    priority: number;
    createAt: string;
    updateAt: string;
};

export enum ESignatureType {
    STYLE = 'STYLE',
    DRAW = 'DRAW',
    UPLOAD = 'UPLOAD',
}

export interface IProviderSignature {
    fullName: string;
    initials: string;
    signatureType?: ESignatureType;
    fontName?: string;
    signatureFileKey?: string;
    isDefault: 0 | 1;
}

export type TVisitBillingInfo = {
    billingMethod: 'INSURANCE' | 'SELF_PAY';
    insuranceCarrier?: string | null;
    insurancePlan?: string | null;
    memberId?: string | null;
    groupId?: string | null;
    cardBrand?: string | null;
    cardLast4?: string | null;
    cardType?: string | null;
};

export interface IVideoTreatmentDetail {
    id: number;
    appointmentName: string;
    serviceSpecialty: string;
    serviceType: string;
    startAt: string;
    endAt: string;
    duration: number;
    createdAt: string;
    patientFirstName: string;
    patientLastName: string;
    patientGender: string;
    patientBirthday: string;
    patientAge: number;
    patientIdFrontUrl: string;
    patientIdBackUrl: string;
    providerId: number;
    idVerified: boolean;
    treatmentPlan: IVideoTreatment;
    prescriptions: TPrescriptionListItem[];
    pharmacySelected: boolean;
    prospect: Prospect;
    attachments: TextVisitAttachment[];
    upcomingVisitAppointments: TServerCalendarAppointmentEventDetail[];
    clientId: number;
    providerTreatmentSubmittedAt: string;
    providerTreatmentSubmitted: boolean;
    formGroups: TFormGroup[];
    historyMedical: string[];
    currentMedications: string[];
    allergies: string[];
    medicationHealth: {
        medications: string[];
        notTaking: boolean;
        others: string[];
    };
    allergyHealth: {
        hasAllergy: boolean;
        allergies: string[];
    };
    conditionHealth: {
        featured: string[];
        notSure: boolean;
    };
    prospectChangeContext: TProspectChangeContext;
    prescribed: boolean;
    online: boolean;
    intakeQuestions: IntakeQuestion[];
    currentWeightAndHeight: {
        weight: number;
        height: number;
    };
    weightLossGoal: {
        weightLossGoal: string;
    };
    visitGoal: {
        visitGoal: string;
    };
    providerEligible: boolean;
    payoutAmount: number;
    providerType: string;
    patientAdditionalComment: string;
    pharmacy?: TPharmacy;
    conditions: string | null;
    aiSummary: string | null;
    aiTags: string | null;
    assignedProviderAt: string | null;
    maritalStatus?: string | null;
    emergencyContacts: TEmergencyContact[];
    intakeFormStatus: EIntakeFormStatus;
    paymentStatus: IPaymentStatus | null;
    providerSignature: IProviderSignature;
    visitBilling?: TVisitBillingInfo;
}

export interface ITreatmentAddendum {
    textVisitTreatmentId: number;
    content: string;
    attachments: TextVisitAttachment[];
}

export interface ITreatmentAddendumItem {
    id: number;
    content: string;
    attachments: TextVisitAttachment[];
    createdAt: string;
    updatedAt: string;
}

export type TStandaloneNoteDetail = {
    id: number;
    businessType: 'STANDALONE';
    businessId: number;
    clientId: number;
    providerId: number;
    specialty?: string | null;
    treatmentSubmittedAt?: string | null;
    treatmentPlan?: string | null;
    aiTreatmentPlan?: string | null;
    aiTreatmentDraftStatus?: boolean;
    autoFollowUp?: boolean;
    autoFollowUpInterval?: number | null;
    autoFollowUpIntervalUnit?: string;
    autoFollowUpMessage?: string | null;
    providerNote?: string | null;
    providerSignature?: IProviderSignature;
    patientFirstName?: string;
    patientLastName?: string;
    attachments?: TextVisitAttachment[];
    treatmentPlanAddendums?: ITreatmentAddendumItem[];
    klarityBillingNote?: string | null;
    diagnoses?: import('types/insuranceBilling').TProviderVisitDiagnosisVo[];
    billingCodes?: import('types/insuranceBilling').TProviderVisitBillingCodeVo[];
};

export type TStandaloneLinkReq = {
    visitType: 'APPOINTMENT' | 'TEXT_VISIT';
    visitId: number | string;
    discardDraft?: boolean;
};